import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GalleryInitialStateType } from '../utils/Types';
import {
  galleryAddMedia,
  galleryGetAllList,
  galleryRemoveMedia,
} from '../services';
import { isAPISuccess } from '../utils/Util';
import { API_STATUS } from '../utils/Constant';
const initialState: GalleryInitialStateType = {
  allList: [],
  apiProgressStatus: '',
};

export const getGalleryAllList = createAsyncThunk(
  'gallery/getGalleryAllList',
  async () => {
    const res = await galleryGetAllList();
    return res.data;
  }
);
export const addGalleryMedia = createAsyncThunk(
  'gallery/addGalleryMedia',
  async (data: any) => {
    const res = await galleryAddMedia(data);
    return res.data;
  }
);
export const removeGalleryMedia = createAsyncThunk(
  'gallery/removeGalleryMedia',
  async (data: any) => {
    const res = await galleryRemoveMedia(data);
    return res.data;
  }
);

export const gallerySlice = createSlice({
  name: 'gallery',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getGalleryAllList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.apiProgressStatus = API_STATUS.SUCCEEDED;
          state.allList = action.payload.result;
        } else {
          state.apiProgressStatus = API_STATUS.FAILED;
          state.allList = action.payload.result;
        }
      })
      .addCase(getGalleryAllList.pending, (state) => {
        state.apiProgressStatus = API_STATUS.LOADING;
      })
      .addCase(getGalleryAllList.rejected, (state) => {
        state.allList = [];
        state.apiProgressStatus = API_STATUS.FAILED;
      });
  },
});

export const gallerySelector = (state: { gallery: GalleryInitialStateType }) =>
  state.gallery;
export default gallerySlice.reducer;
